export enum FeedbackCategory {
    Feature = "feature",
    Bug = "bug",
    Usability = "usability",
    Content = "content",
    Performance = "performance",
    General = "general",
}